<template>
  <div class="verifyWrap">
    <Header></Header>
    <div class="verifyContent">
      <!-- 成功 -->
      <div class="fxRow pt80" v-if="status">
        <p class="blue fs56 el-icon-success"></p>
      </div>
      <!-- 失败 -->
      <div class="fxRow pt80" v-if="!status">
        <p class="red fs56 el-icon-error"></p>
      </div>
    </div>
    <div>
      <!-- 成功 -->
      <div class="bullshit" v-if="status">
        <p class="bullshit__headline">
          <span v-if="page == 'changeEmail'">{{ $t("verify.emailSucceed") }}</span>
          <span v-if="page == 'signUp'">{{ $t("verify.signSucceed") }}</span>
        </p>
        <p class="bullshit__info">
          <span v-if="page == 'changeEmail'">{{ $t("verify.emailSucceedTipe") }}</span>
          <span v-if="page == 'signUp'">{{ $t("verify.signSucceedTipe") }}</span>
        </p>
        <div>
          <router-link to="/login" class="linkTo" v-if="page == 'changeEmail'">
            <el-button type="primary" size="small" round>{{ $t("verify.login") }}</el-button>
          </router-link>
          <router-link to="/login" class="linkTo" v-if="page == 'signUp'">
            <el-button type="primary" size="small" round>{{ $t("verify.login") }}</el-button>
          </router-link>
        </div>
      </div>

      <!-- 失败 -->
      <div class="bullshit" v-if="!status">
        <p class="bullshit__headline">
          <span v-if="page == 'changeEmail'">{{ $t("verify.emailError") }}</span>
          <span v-if="page == 'signUp'">{{ $t("verify.signError") }}</span>
        </p>
        <p class="bullshit__info">
          <span v-if="page == 'changeEmail'">{{ $t("verify.emailErrorTipe") }}</span>
          <span v-if="page == 'signUp'">{{ $t("verify.signErrorTipe") }}</span>
        </p>
        <div>
          <router-link to="/email" class="linkTo" v-if="page == 'changeEmail'">
            <el-button type="primary" size="small" round>{{ $t("verify.edit") }}</el-button>
          </router-link>
          <router-link to="/register" class="linkTo" v-if="page == 'signUp'">
            <el-button type="primary" size="small" round>{{ $t("verify.register") }}</el-button>
          </router-link>
        </div>
      </div>
    </div>
    <div class="footBox">
      <p class="black88 fs12">
        {{ $t("login.copyright") }}
        <a href="https://beian.miit.gov.cn/" target="_blank" class="blue">{{ $t("login.records") }}</a>
      </p>
    </div>
  </div>
</template>

<script>
import Header from "./components/Header";
import { mapActions } from "vuex";
export default {
  name: "Verify",
  data() {
    return {
      page: null, // changeEmail, signUp
      status: null, // true, false
    };
  },
  components: {
    Header,
  },
  methods: {
    ...mapActions("user", ["logout"]),
  },
  created() {
    // 检查url是否存在参数(id)
    if (this.$route.query.page && this.$route.query.status) {
      this.page = this.$route.query.page;
      this.status = JSON.parse(this.$route.query.status);
      if (this.status) {
        // 退出登录
        this.logout();
      }
    } else {
      // 缺少参数
      this.$message({
        message: this.$t("common.error.scarce"),
        type: "error",
        duration: 1000,
        onClose: () => {
          this.$router.replace({ path: "/" });
        },
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.bullshit {
  padding: 26px 0 30px;
  overflow: hidden;
  text-align: center;
}
.bullshit__oops {
  font-size: 32px;
  line-height: 40px;
  color: #1482f0;
  margin-bottom: 40px;
  animation-fill-mode: forwards;
  font-weight: 700;
}
.bullshit__headline {
  font-size: 26px;
  color: #222;
  margin-bottom: 6px;
  animation-delay: 0.1s;
  animation-fill-mode: forwards;
  font-weight: 700;
}
.bullshit__info {
  font-size: 16px;
  color: grey;
  margin-bottom: 30px;
  animation-delay: 0.2s;
  animation-fill-mode: forwards;
}
.footBox {
  position: absolute;
  bottom: 14px;
  left: 0;
  width: 100%;
  text-align: center;
  z-index: 10000;
}
</style>
